import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [image, setImage] = useState('');

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const data = { token: localStorage.getItem('token') };
      axios.post('employee/check/login', data).then((response) => {
        const data = response.data.data;
        const employee = data.employee;
        setName(employee.f_name);
        setDesignation(employee.designation);
        setImage(employee.image);
      });
    } else {
      window.location.replace('login');
    }
  }, []);

  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm">
      <div className="container-fluid">
        <Link className="navbar-brand d-flex align-items-center" to="/home">
          <div
            className="me-2"
            style={{
              width: 36,
              height: 36,
              background: 'var(--brand)',
              borderRadius: 8,
            }}
          />
          <span className="fw-bold" style={{ color: 'var(--brand)' }}>
            SmartHR
          </span>
        </Link>

        <div className="d-flex align-items-center">
          <div className="text-end me-3 d-none d-md-block">
            <div className="fw-semibold">{name}</div>
            <div className="text-muted small">{designation}</div>
          </div>
          <img
            src={image || '/assets/images/default-avatar.png'}
            alt="avatar"
            width="48"
            height="48"
            className="rounded-circle"
            style={{ objectFit: 'cover', cursor: 'pointer' }}
            onClick={() => navigate('/profile')}
          />
        </div>
      </div>
    </nav>
  );
}
